import api from '../api';

const propertyInspectionsService = {
  // Get property details
  getPropertyDetails: async (propertyId) => {
    return await api.get(`/properties/${propertyId}`);
  },

  // Get inspections for a property
  getInspections: async (propertyId, statusId = null) => {
    const params = statusId ? { status_id: statusId } : {};
    return await api.get(`/inspections/property/${propertyId}`, { params });
  },

  // Get inspection counts for a property
  getInspectionCounts: async (propertyId) => {
    return await api.get(`/inspections/property/${propertyId}/counts`);
  },

  // Get building managers list
  getBuildingManagers: async () => {
    return await api.get('/users/building-managers');
  },

  // Get inspection types
  getInspectionTypes: async () => {
    return await api.get('/inspections/types');
  },

  // Create new inspection
  createInspection: async (data) => {
    return await api.post('/inspections', data);
  },

  // Update inspection
  updateInspection: async (inspectionId, data) => {
    return await api.put(`/inspections/${inspectionId}`, data);
  },

  // Delete inspection
  deleteInspection: async (inspectionId) => {
    return await api.delete(`/inspections/${inspectionId}`);
  },

  // Get inspection details
  getInspectionDetails: async (inspectionId) => {
    return await api.get(`/inspections/${inspectionId}`);
  },

  // Get DataTable data for inspections
  getInspectionsDataTable: async (propertyId, statusId = null) => {
    const params = statusId ? { status_id: statusId } : {};
    return await api.post(`/inspections/property-dt/${propertyId}`, params);
  },

  // Export inspections as CSV
  exportInspectionsCSV: async (propertyId, statusId = null) => {
    const params = statusId ? { status_id: statusId } : {};
    return await api.get(`/inspections/property/${propertyId}/export/csv`, { 
      params,
      responseType: 'blob'
    });
  },

  // Export inspections as PDF
  exportInspectionsPDF: async (propertyId, statusId = null) => {
    const params = statusId ? { status_id: statusId } : {};
    return await api.get(`/inspections/property/${propertyId}/export/pdf`, { 
      params,
      responseType: 'blob'
    });
  }
};

export default propertyInspectionsService; 